<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/role' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>酶切位点库</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-form :inline="true" :model="cleavageSite" class="demo-form-inline" size="mini">
                <el-form-item label="酶切位点名称" clearable>
                    <el-input v-model="cleavageSite.condition.cleavageSiteName" placeholder="酶切位点名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="queryCleavageSite">查询</el-button>
                    <el-button type="primary" @click="toAddCleavageSite">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table
            :data="cleavageSites"
            :height="tableHeight"
            size="mini"
            border
            @selection-change="handleSelectionChange"
            ref="tb"
            style="width: 100%">
                <el-table-column  type="selection" width="55"></el-table-column>
                <el-table-column fixed prop="cleavageSiteName" label="酶切位点名称"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="toUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10,20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog title="新增酶切位点" :visible.sync="dialogFormVisible"  append-to-body>
            <el-form :inline="true" :model="addCleavageSite" ref="addForm" size="mini">
                <div v-for="(item, index) in addCleavageSite.cleavageSiteList" :key="index">
                    <el-form-item label="酶切位点名称" :prop="'cleavageSiteList.'+index+'.cleavageSiteName'" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                        <el-input v-model="item.cleavageSiteName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addItem()"> + </el-button>
                        <el-button @click="deleteItem(index)"> – </el-button>
                    </el-form-item>
                </div>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submitCleavageSite('addForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
        <el-dialog title="修改酶切位点" :visible.sync="updateDialog"  append-to-body>
            <el-form :inline="true" :model="updateCleavageSite" size="mini">
                <el-form-item label="载体名称" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                    <el-input v-model="updateCleavageSite.cleavageSiteName" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="submitCleavageSiteUpdate()" type="primary">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
    
</template>

<script>

    export default {
        name:'Carrier',
        data() {
            return {
                cleavageSite: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                cleavageSites: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                tableHeight1: "",//表格高度
                tableHeight2: "",//表格高度
                dialogFormVisible: false,
                addCleavageSite:{
                    cleavageSiteList:[{cleavageSiteName : ""}]  //接收每个input框的值
                },
                updateDialog: false,
                updateCleavageSite: {},
                selectedCarrier: {},
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryCleavageSite();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryCleavageSite();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryCleavageSite();
                })
                .catch(() => {});
            },
            queryCleavageSite() {
                this.cleavageSite.pageNum = this.currentPage;
                this.cleavageSite.pageSize = this.pageSize;
                this.$axios.post("/cleavageSite/find",this.cleavageSite).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.cleavageSites = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
                this.tableHeight1 = this.tableHeight/2;
                this.tableHeight2 = this.tableHeight/2 - 10;
            },
            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(selection) {
                //this.multipleSelection = val;
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedCarrier = selection.pop()
                } else {
                    this.selectedCarrier = {}
                }
            },
            toAddCleavageSite() {
                this.dialogFormVisible = true;
                while(this.addCleavageSite.cleavageSiteList.length > 0) {
                    this.addCleavageSite.cleavageSiteList.pop();
                }
                this.addCleavageSite.cleavageSiteList.push({
                    cleavageSiteName: "",
                });
            },
            addItem() {
                this.addCleavageSite.cleavageSiteList.push({
                    cleavageSiteName: "",
                });
            },
            deleteItem(i){
                if (this.addCleavageSite.cleavageSiteList.length <= 1) {
                    return false;
                }
                this.addCleavageSite.cleavageSiteList.splice(i, 1);
            },
            submitCleavageSite(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/cleavageSite/batchSave",this.addCleavageSite.cleavageSiteList).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.info(res.data.message);
                                this.dialogFormVisible = false;
                                this.queryCleavageSite();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
                });
            },
            submitCleavageSiteUpdate() {
                this.$axios.post("/cleavageSite/update",this.updateCleavageSite).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.info(res.data.message);
                            this.updateDialog = false;
                            this.queryCleavageSite();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            toUpdate(row) {
                this.updateCleavageSite = row;
                this.updateDialog = true;
            },
            del(row) {
                this.$confirm('您确认删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post("/cleavageSite/delete",row).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.queryCleavageSite();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
        mounted() {
            this.queryCleavageSite();
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
